import { useState, useEffect } from "react";

const CONSENT_KEY = "ab_cookie_consent";
const CLARITY_TAG = "wp0id8npoc";

type ConsentState = {
  necessary: true;
  analytics: boolean;
  decidedAt: number;
};

function loadClarity() {
  if (typeof window === "undefined" || (window as any).__clarityLoaded) return;
  (window as any).__clarityLoaded = true;
  /* eslint-disable */
  (function (c: any, l: any, a: any, r: any, i: any, t?: any, y?: any) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    t = l.createElement(r); t.async = 1;
    t.src = "https://www.clarity.ms/tag/" + i + "?ref=bwt";
    y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", CLARITY_TAG);
  /* eslint-enable */
}

export function useCookieConsent() {
  const [consent, setConsent] = useState<ConsentState | null>(null);
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(CONSENT_KEY);
      if (raw) setConsent(JSON.parse(raw));
    } catch {}
    setHydrated(true);
  }, []);

  useEffect(() => {
    if (consent?.analytics) loadClarity();
  }, [consent]);

  function save(analytics: boolean) {
    const next: ConsentState = { necessary: true, analytics, decidedAt: Date.now() };
    try { localStorage.setItem(CONSENT_KEY, JSON.stringify(next)); } catch {}
    setConsent(next);
  }

  return {
    hydrated,
    hasDecided: consent !== null,
    analyticsEnabled: consent?.analytics ?? false,
    acceptAll: () => save(true),
    rejectAll: () => save(false),
    savePreferences: (analytics: boolean) => save(analytics),
  };
}
